export const opMap = {
  0: 'open',
  1: 'closed',
  2: '=',
  3: '≠',
  4: '>',
  5: '<',
  6: '≥',
  7: '≤',
}
export const OPERATORS = {
  OPEN: 0,
  CLOSED: 1,
  EQUAL: 2,
  NOT_EQUAL: 3,
  GREATER_THAN: 4,
  LESS_THAN: 5,
  GREATER_THAN_OR_EQUAL: 6,
  LESS_THAN_OR_EQUAL: 7,
}

export const EVAL_VALUES = {
  TRUE: 1,
  FALSE: 0,
}

export const resolveBooleanString = (val) => {
  if (val === true || val === 'true' || val === 'True' || val === 'TRUE') {
    return true
  }
  if (val === false || val === 'false' || val === 'False' || val === 'FALSE') {
    return false
  }
  return null
}

export function renderArray(array, renderItemFunc) {
  return array.map((item) => renderItemFunc(item))
}
